import React from 'react';

export default function ProductImage({
  className = '',
  img = 'https://cdn.foodrevolution.org/ppp/ppp-product-image-v20220909.png',
  width = '1200',
  height = '740',
  altText = 'Plant-Powered Playbook graphic',
  maxHeight = null,
  ...props
}) {
  let styles = {
    maxHeight: `${maxHeight}px`,
    width: 'auto'
  };
  return (
    <>
      <img
        className={className}
        src={img}
        width={width}
        height={height}
        alt={altText}
        style={maxHeight ? styles : null}
      />
    </>
  );
}
